import { Claim } from '../@types/organization';
import { NON_ASSIGNABLE_PERMISSION_CLAIMS, PermissionClaims } from 'access/claims';

export const ROLE_NAME_TO_INT: Record<string, number> = {
  CompanyAdmin: 1,
  CompanyUser: 2
};

export const ROLE_INT_TO_NAME: Record<number, string> = {
  1: 'CompanyAdmin',
  2: 'CompanyUser'
};

const getRoleValue = (role?: number | string) => {
  if (typeof role === 'number') {
    return role;
  }

  if (!role) {
    return ROLE_NAME_TO_INT.CompanyUser;
  }

  const roleValue = ROLE_NAME_TO_INT[role] ?? Number(role);
  return Number.isNaN(roleValue) ? ROLE_NAME_TO_INT.CompanyUser : roleValue;
};

const getPermissionClaimValues = (claims: Claim[] = []) => {
  const permissionValues = new Set(
    claims
      .filter((c) => c.claimType === 'permissions')
      .map((c) => c.claimValue)
      .filter((claimValue) => !NON_ASSIGNABLE_PERMISSION_CLAIMS.has(claimValue))
  );

  if (
    permissionValues.has(PermissionClaims.UserCreate) ||
    permissionValues.has(PermissionClaims.UserDelete)
  ) {
    permissionValues.add(PermissionClaims.TenantUserAccessCrud);
  } else {
    permissionValues.delete(PermissionClaims.TenantUserAccessCrud);
  }

  return Array.from(permissionValues);
};

export const buildUserAccessPayload = (role?: number | string, claims: Claim[] = []) => {
  return {
    role: getRoleValue(role),
    claims: getPermissionClaimValues(claims),
    managementClaims: claims
      .filter((c) => c.claimType === 'management')
      .map((c) => (c.claimValue === 'surveyJs' ? 'surveyjs' : c.claimValue)),
    featureClaims: claims.filter((c) => c.claimType === 'features').map((c) => c.claimValue)
  };
};
